import { createSlice, createSelector } from "@reduxjs/toolkit";

const initialState = {
  isLoadingFile: false,
  isPrintServiceUnavailable: false,
  totalTracked: null,
  showBatteryGradeSlideout: false,
  batteryGradeSlideoutData: null,
  isToUseAuthZero: false,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  selectors: {
    GET_STATE: createSelector([(state) => state], (state) => {
      return {
        app: {
          isLoadingFile: state?.isLoadingFile,
          isPrintServiceUnavailable: state?.isPrintServiceUnavailable,
          totalTracked: state?.totalTracked,
          showBatteryGradeSlideout: state?.showBatteryGradeSlideout,
          batteryGradeSlideoutData: state?.batteryGradeSlideoutData,
          isToUseAuthZero: state?.isToUseAuthZero,
        },
      };
    }),
  },
  reducers: {
    SET_IS_LOADING_FILE: (state, action) => {
      state.isLoadingFile = action.payload;
    },
    SET_IS_PRINT_SERVICE_UNAVAILABLE: (state, action) => {
      state.isPrintServiceUnavailable = action.payload;
    },
    SET_TOTAL_TRACKED: (state, action) => {
      state.totalTracked = action.payload;
    },
    SHOW_BATTERY_GRADE_SLIDEOUT: (state, action) => {
      state.showBatteryGradeSlideout = action.payload.showBatteryGradeSlideout;
      state.batteryGradeSlideoutData =
        action.payload.batteryGradeSlideoutData ?? null;
    },
    SET_IS_TO_USE_AUTH_ZERO: (state, action) => {
      state.isToUseAuthZero = action.payload;
    },
  },
});

export const {
  SET_IS_LOADING_FILE,
  SET_IS_PRINT_SERVICE_UNAVAILABLE,
  SET_TOTAL_TRACKED,
  SHOW_BATTERY_GRADE_SLIDEOUT,
  SET_IS_TO_USE_AUTH_ZERO,
} = appSlice.actions;

export const { GET_STATE } = appSlice.selectors;

export default appSlice.reducer;
